import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	x: 0,
	y: 0,
	viewBox: "0 0 40 32",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 6,
		cy: 15,
		r: 6,
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			begin: 0,
			dur: "1s",
			repeatCount: "indefinite",
			type: "translate",
			values: "0 6 ;0 3 ; 0 1;0 -2;0 -8;0 -8;0 0; 0 6"
		})
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 32,
		cy: 15,
		r: 6,
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			begin: .5,
			dur: "1s",
			repeatCount: "indefinite",
			type: "translate",
			values: "0 6 ;0 3 ; 0 1;0 -2;0 -8;0 -8;0 0; 0 6"
		})
	})]
});
export default SvgLoader;
